import React, { useContext, useEffect, useState, useRef } from "react";
import Flag from "react-world-flags";
import { UserAuthContext } from "../../App";
import { useNavigate } from "react-router-dom";
import Select, { components } from "react-select";
import { Formik } from "formik";
import { commonPoint } from "../../common/Apicall";
import { changeAccountTypeApi } from "../../Apis/PaymentApi";
import { CircularProgress } from "@mui/material";
import Profile from "../../assets/flag images/Profile.png";
import Logo from "../../assets/flag images/Logo.png";
import App from "../../assets/flag images/App.png";
import Naay from "../../assets/Member/Naay.png";
import background from "../../assets/Member/background.png";
import laptop from "../../assets/Member/laptop.png";
import flag from "../../assets/Member/flag.png";
// import SectionData from "./SectionData";
import naaya from "../../assets/Member/naaya.png";
import Carsoule from "./Carsoule";
import loan from "../../assets/Member/loan.png";
import Service from "./Service";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from "@radix-ui/react-dropdown-menu";
import {
  CurrencyDropdownLabelSVG,
  GetTheAppSVG,
  QuotationPageLogoSVG,
  ScrollToTopSVG,
} from "../../assets/svg/allSvg";
import { CurrencyContext } from "../../provider/CurrencyProvider";
import {
  CameraSVG,
  CategoriesSVG,
  DollarPouchSVG,
  MessageSVG,
  SearchSVG,
  UserSVG,
  WishListSVG,
} from "../../assets/svg/allSvg";
import Branding from "./Branding";
import SectionData from "./SectionData";

const options = [
  { value: "India", label: "India" },
  { value: "USA", label: "USA" },
  { value: "China", label: "China" },
  { value: "Japan", label: "Japan" },
];

const currencyOptions = [
  { value: "INR", label: "INR (₹) - India", country: "IN" },
  { value: "EUR", label: "EUR (€) - Germany", country: "EU" },
  { value: "USD", label: "USD ($) - USA", country: "US" },
  { value: "GBP", label: "GBP (£) - UK", country: "GB" },
  { value: "AED", label: "AED (د.إ) - UAE", country: "AE" },
  { value: "AUD", label: "AUD (A$) - Australia", country: "AU" },
  { value: "CAD", label: "CAD ($) - Canada", country: "CA" },
  { value: "CNY", label: "CNY (¥) - China", country: "CN" },
  { value: "JPY", label: "JPY (¥) - Japan", country: "JP" },
  { value: "KRW", label: "KRW (₩) - S. Korea", country: "KR" },
  { value: "SAR", label: "SAR (ر.س) - Arabia", country: "SA" },
  { value: "RUB", label: "RUB (₽) - Russia", country: "RU" },
  { value: "AFN", label: "AFN (؋) - Afghanistan", country: "AF" },
  { value: "ALL", label: "ALL (Lek) - Albania", country: "AL" },
  { value: "AMD", label: "AMD (Դ) - Armenia", country: "AM" },
  // Add more currencies as needed
];

const LandingPage = () => {
  async function firebaseSignup(values) {
    try {
      const storeResponse = await fetch(
        `${commonPoint}/api/v1/store/registerSeller`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            storeID: userData?.uid,
            storeDesc: "",
            storeLogo: "",
            phoneNumber: userData?.phone || values.phoneNumber,
            storeName: values.storeName,
            storeAddress: values.address,
            city: values.city,
            country: values.country,
            state: values.state,
            gstNumber: userData?.gstNumber || values.gstNumber,
            postcode: "400050",
            isVerified: 0,
          }),
        }
      );

      if (!storeResponse.ok) {
        console.error("Store registration failed");
      }

      const response = await storeResponse.json();
      if (response?.message === "Store created successfully") {
        await changeAccountTypeApi();
      }

      toggleRegisterForm();
    } catch (error) {
      console.error("Error:", error);
    }
  }
  const toggleVerifyName = () => {
    setVerifySeller((prev) => !prev);
  };

  const shipToDropdownRef = useRef(null);
  const dropdownRef = useRef(null);
  const [userData, setUserData] = useState({
    uid: "",
    name: "",
    email: "",
    phone: "",
    billingAddress: "",
    accountType: "",
    gstNumber: "",
    storeName: "",
    country: "",
  });
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [sellerPopUp, setSellerPopUp] = useState(false);
  const [emailStatus, setEmailStatus] = useState("");
  const [loader, setLoader] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const [tempLanguage, setTempLanguage] = useState("en"); // Temporary state for language selection
  const { currency, setCurrency } = useContext(CurrencyContext);
  const [selectedOption, setSelectedOption] = useState(
    currencyOptions.find((option) => option.value === currency)
  );
  const [verifySeller, setVerifySeller] = useState(false);

  const [selectedLocation, setSelectedLocation] = useState(null);
  const { userUid, isLoggedIn } = useContext(UserAuthContext);

  const [locationOpen, setLocationOpen] = useState(false);

  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div className="flex items-center">
          <Flag
            code={props.data.country}
            className="w-[15px] h-[10px] mr-[9px]"
          />
          <div className="font-medium text-[12px] text-black">
            {props.data.label}
          </div>
        </div>
      </components.Option>
    );
  };
  const CustomSingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <div className="flex items-center">
          <Flag
            code={props.data.country}
            className="w-[15px] h-[10px] mr-[9px]"
          />
          <div className="font-medium text-[12px] text-black">
            {props.data.label}
          </div>
        </div>
      </components.SingleValue>
    );
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      boxShadow: state.isFocused ? null : null,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#FF6300"
        : state.isFocused
        ? "lightgrey"
        : "white",
      color: state.isSelected ? "white" : "black",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : null,
    }),
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleSelectChange = (option) => {
    setSelectedOption(option);
  };
  const handleClickOutside = (event) => {
    if (
      shipToDropdownRef.current &&
      !shipToDropdownRef.current.contains(event.target)
    ) {
      setLocationOpen(false);
    }
  };

  useEffect(() => {
    if (locationOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [locationOpen]);

  const handleLocationChange = (selectedOption) => {
    setSelectedLocation(selectedOption);
    setLocationOpen(false);
    handleLocationSelect(selectedOption);
  };

  const handleLocationSelect = (item) => {
    setSelectedLocation(item);
    setLocationOpen(false);
  };

  const handleOrdersClick = () => {
    if (isLoggedIn) {
      navigate("/orders");
    } else {
      navigate("/login");
    }
  };
  const toggleRegisterForm = () => {
    setSellerPopUp((prev) => !prev);
  };
  const handleUserIdClick = () => {
    if (isLoggedIn) {
      navigate("/orders/overview");
    } else {
      navigate("/login");
    }
  };

  const handleSignInToAddressClick = () => {
    if (isLoggedIn) {
      navigate("/orders/overview"); // Redirect to the user's profile or order overview page
    } else {
      navigate("/login"); // Redirect to the login page
    }
  };

  const ShipToCustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div className="flex items-center">
          <Flag
            code={props.data.country}
            className="w-[15px] h-[10px] mr-[9px]"
          />
          <div className="font-medium text-[12px] text-black">
            {props.data.label}
          </div>
        </div>
      </components.Option>
    );
  };

  const ShipToCustomSingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <div className="flex items-center">
          <Flag
            code={props.data.country}
            className="w-[15px] h-[10px] mr-[9px]"
          />
          <div className="font-medium text-[12px] text-black">
            {props.data.label}
          </div>
        </div>
      </components.SingleValue>
    );
  };

  const handleLanguageSelect = (event) => {
    setTempLanguage(event.target.value); // Update temporary language state
  };

  const handleLanguageChange = () => {
    setSelectedLanguage(tempLanguage); // Update selected language on button click
    // Additional logic for handling language change, e.g., updating UI text or fetching content in the selected language
  };
  const handleChangeCurrency = () => {
    setCurrency(selectedOption.value);
    setIsOpen(false); // Close the dropdown
  };

  const shipToOptions = [
    { value: "INR", label: "India", country: "IN" },
    { value: "EUR", label: "Germany", country: "EU" },
    { value: "USD", label: "USA", country: "US" },
    { value: "GBP", label: "UK", country: "GB" },
    { value: "AED", label: "UAE", country: "AE" },
    { value: "AUD", label: "Australia", country: "AU" },
    { value: "CAD", label: "Canada", country: "CA" },
    { value: "CNY", label: "China", country: "CN" },
    { value: "JPY", label: "Japan", country: "JP" },
    { value: "KRW", label: "South Korea", country: "KR" },
    { value: "SAR", label: "Saudi Arabia", country: "SA" },
    { value: "RUB", label: "Russia", country: "RU" },
    { value: "AFN", label: "Afghanistan", country: "AF" },
    { value: "ALL", label: "Albania", country: "AL" },
    { value: "AMD", label: "Armenia", country: "AM" },
    // Add more currencies as needed
  ];

  return (
    <>
      <div className="w-[1440px] h-[600px] m-auto bg-white">
        <div className="flex m-auto w-[1440px] h-[70px] items-center justify-center gap-40">
          {/* left side */}
          <div className="">
            <img src={Logo} alt="" className="w-[191px] h-[44px]" />
          </div>
          {/* right side */}
          <div className="flex items-center">
            <div className="flex items-center gap-x-[5px] mr-[10px]">
              <button className="w-[44px] h-[18px] text-[12px] select-none">
                Ship to:
              </button>
              <div className="relative" ref={shipToDropdownRef}>
                <div
                  className="flex gap-x-2 cursor-pointer items-center justify-between"
                  onClick={() => setLocationOpen(!locationOpen)}
                >
                  {selectedLocation ? (
                    <>
                      <Flag
                        code={selectedLocation.country}
                        alt="ShipToFlag"
                        className="h-[10px] w-[15px]"
                      />
                    </>
                  ) : (
                    <span className="font-regular text-[13px] text-black">
                      Select Location
                    </span>
                  )}
                  <svg width="10" height="9" viewBox="0 0 10 3" fill="none">
                    <path
                      d="M1 1L4.5 4L8 1"
                      stroke="black"
                      strokeOpacity="0.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {locationOpen && (
                  <div className="absolute -left-[130px] mt-2 w-[307px] bg-white rounded-[10px] shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)] z-10">
                    <div className="flex flex-col items-center justify-center p-4">
                      <p className="text-[#FF6300] text-[14px] font-semibold">
                        Your location
                      </p>
                      <p className="my-[15px] text-[12px] font-medium text-center">
                        Shipping charges may vary depending on your location.
                      </p>

                      {!isLoggedIn && (
                        <>
                          <button
                            className="w-[192px] h-[36px] bg-[#FF6300] text-white text-[12px] rounded-[5px] font-semibold"
                            onClick={handleSignInToAddressClick}
                          >
                            Sign In to add Address
                          </button>
                          <div className="flex items-center pb-[14px] pt-[17px] w-full justify-between">
                            <div className="w-20 border-t-2 border-gray-300" />
                            <p className="text-[12px] font-medium text-black w-16 text-center">
                              Or
                            </p>
                            <div className="w-20 border-t-2 border-gray-300" />
                          </div>
                        </>
                      )}

                      <div className="w-full mb-5 flex flex-col">
                        <h2 className="text-left text-black text-[12px] font-medium mb-2">
                          Enter Country Name
                        </h2>
                        <Select
                          options={shipToOptions}
                          value={selectedLocation}
                          onChange={handleLocationChange}
                          className="w-full font-medium text-[12px]"
                          components={{
                            Option: ShipToCustomOption,
                            SingleValue: ShipToCustomSingleValue,
                          }}
                          isSearchable={false}
                        />
                      </div>

                      <div className="w-full mb-5 flex flex-col">
                        <h2 className="text-left text-black text-[12px] font-medium mb-2">
                          Enter Pincode
                        </h2>
                        <input
                          type="text"
                          className="w-full h-[37px] px-2 text-[12px] font-medium border rounded-[5px]"
                          placeholder="400050"
                        />
                      </div>

                      <button className="w-[130px] h-[36px] bg-[#FF6300] text-white text-[12px] rounded-[5px] font-semibold">
                        Save
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr className="opacity-45 w-[2px] h-[15px] bg-black" />

            <div className="flex items-center mx-[15px] justify-center w-auto h-[20px]">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <div className="flex items-center gap-x-2 cursor-pointer">
                    <p className="w-[71px] h-[18px] font-regular text-[12px]">
                      Language -
                    </p>
                    <img
                      src={require("../../assets/homepage/navbar/USAFlag.png")}
                      className="h-[12px]"
                      alt="LanguageImg"
                    />
                    <p>English US</p>
                    <svg
                      width="10"
                      height="9"
                      viewBox="0 0 10 3"
                      fill="none"
                      className="cursor-pointer"
                    >
                      <path
                        d="M1 1L4.5 4L8 1"
                        stroke="black"
                        strokeOpacity="0.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                  className={`z-10 w-[307px] h-[241px] mt-4 px-8 bg-white rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]`}
                >
                  <p className="pt-[22px] text-[#FF6300] text-sm font-semibold text-[14px] text-center">
                    Change Language
                  </p>
                  <p className="text-left mb-[15px] mt-[15px] text-xs font-medium">
                    Select Language
                  </p>
                  <div className="flex flex-col justify-center">
                    <label htmlFor="language" className="mr-2">
                      Select Language:
                    </label>
                    <select
                      id="language"
                      value={tempLanguage}
                      onChange={handleLanguageSelect}
                      className="bg-white border border-gray-300 rounded-lg px-4 py-2 shadow-sm focus:outline-none focus:border-blue-500"
                    >
                      <option value="en">English</option>
                      <option value="es">Spanish</option>
                      <option value="fr">French</option>
                      <option value="de">German</option>
                      <option value="zh">Chinese</option>
                    </select>
                  </div>
                  <div className="mt-[30px] flex justify-center">
                    <button
                      onClick={handleLanguageChange}
                      className="w-28 h-10 bg-[#FF6300] text-[12px] rounded-md text-white font-semibold"
                    >
                      Change
                    </button>
                  </div>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
            <hr className="opacity-45 w-[2px] h-[15px] bg-black" />

            <div className="flex items-center mx-[15px] justify-center w-auto h-[20px]">
              <p className="w-[65px] h-[18px] text-[12px] select-none">
                Currency :
              </p>
              <div className="relative" ref={dropdownRef}>
                <div
                  className="flex gap-x-2 items-center cursor-pointer"
                  onClick={toggleDropdown}
                >
                  <Flag
                    code={selectedOption.country}
                    className="h-[10px] w-[15px]"
                    alt="CountryFlag"
                  />
                  <p className="select-none">{selectedOption.label}</p>
                  {CurrencyDropdownLabelSVG}
                </div>
                {isOpen && (
                  <div className="absolute -left-[130px] z-10 w-[307px] h-[241px] mt-2 px-8 bg-white rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
                    <p className="pt-[22px] text-[#FF6300] text-sm font-semibold text-[14px] text-center">
                      Change Currency
                    </p>
                    <p className="text-left mb-[8px] mt-[24px] text-[12px] font-medium">
                      Select Currency
                    </p>

                    <Select
                      value={selectedOption}
                      onChange={handleSelectChange}
                      options={currencyOptions}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      components={{
                        Option: CustomOption,
                        SingleValue: CustomSingleValue,
                      }}
                      isSearchable={false}
                      styles={customStyles}
                    />
                    <div className="mt-[40px] flex justify-center">
                      <button
                        className="w-28 h-10 bg-[#FF6300] text-[12px] rounded-md text-white font-semibold"
                        onClick={handleChangeCurrency}
                      >
                        Change
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr className="opacity-45 w-[2px] h-[15px] bg-black" />

            {/* get the app */}
            <div className="flex items-center gap-2 m-2">
              <img src={App} alt="" />
              <a
                href="https://play.google.com/store/apps/details?id=com.naayatrade.naayatrade&pli=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className="text-[12px] font-normal">Get the App</p>{" "}
              </a>
            </div>
            <div className="flex gap-x-[30px] m-2">
              <button>
                <div className="flex gap-x-1 items-center">
                  {DollarPouchSVG}
                  <button className="text-[12px]" onClick={toggleRegisterForm}>
                    Sell On Naayatrade
                  </button>
                  {sellerPopUp && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black h-[710px] bg-opacity-50 z-50">
                      <div className="w-[606px] h-[690px] bg-white rounded-[10px] items-center justify-between text-center">
                        <div className="w-full">
                          <div className="flex items-center justify-between">
                            <div className="w-[174px] h-[27px] flex-shrink-0 mt-[13px] ml-[29px] text-[18px] font-semibold text-[#FF8100] leading-[27px] text-start select-none">
                              Seller Registration
                            </div>
                          </div>
                        </div>
                        <Formik
                          initialValues={{
                            name: "",
                            phoneNumber: "",
                            email: "",
                            storeName: "",
                            gstNumber: "",
                            isAgree: false,
                            country: "",
                            state: "",
                            city: "",
                            address: "",
                          }}
                          validate={(values) => {
                            const errors = {};
                            // name
                            if (!userData?.name && !values.name) {
                              errors.name = "Required";
                            }

                            // phoneNumber
                            if (
                              !userData?.phone &&
                              (!values.phoneNumber ||
                                !/^\+?\d{10,15}$/i.test(values.phoneNumber))
                            ) {
                              errors.phoneNumber = !values.phoneNumber
                                ? "Required"
                                : "Invalid Phone Number";
                            }

                            // email
                            if (!userData?.email) {
                              if (!values.email) {
                                errors.email = "Required";
                              } else if (
                                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                  values.email
                                )
                              ) {
                                errors.email = "Invalid email address";
                              }
                            }

                            // gstNumber
                            if (!userData?.gstNumber) {
                              if (!values.gstNumber) {
                                errors.gstNumber = "Required";
                              } else if (
                                !/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/i.test(
                                  values.gstNumber
                                )
                              ) {
                                errors.gstNumber = "Invalid GST Number";
                              }
                            }

                            if (!values.isAgree)
                              errors.isAgree =
                                "You must agree to the terms and conditions";

                            return errors;
                          }}
                          onSubmit={async (values) => {
                            try {
                              firebaseSignup(values);
                            } catch (err) {
                              console.log("Firebase error");
                            }
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                          }) => (
                            <div>
                              <div className="flex gap-x-[45px] w-full pl-[29px] mt-[10px]">
                                <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                                  <p className="text-[14px] font-medium w-[45px] h-[21px] text-black">
                                    Name
                                  </p>
                                  <input
                                    name="name"
                                    disabled={userData?.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={userData?.name || values.name}
                                    className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                    placeholder="Enter your name"
                                  />
                                  {errors.name && (
                                    <p className="text-red-600 text-[12px]">
                                      {errors.name}
                                    </p>
                                  )}
                                </div>

                                <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                                  <p className="text-[14px] font-medium w-[109px] h-[21px] text-black">
                                    Phone Number
                                  </p>
                                  <input
                                    maxLength={10}
                                    name="phoneNumber"
                                    disabled={userData?.phone}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={
                                      userData?.phone || values.phoneNumber
                                    }
                                    className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                    placeholder="Enter your phone number"
                                  />
                                  {errors.phoneNumber && (
                                    <p className="text-red-600 text-[12px]">
                                      {errors.phoneNumber}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="flex flex-col float-start pl-[29px] text-left w-full mt-[10px]">
                                <p className="text-[14px] font-medium w-[109px] text-black">
                                  Email
                                </p>
                                <input
                                  name="email"
                                  disabled={userData?.email}
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={userData.email || values.email}
                                  className="w-[526px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                  placeholder="Enter your Email ID"
                                />
                                {errors.email && (
                                  <p className="text-red-600 text-[12px]">
                                    {errors.email}
                                  </p>
                                )}
                              </div>

                              <div className="flex gap-x-[45px] w-full pl-[29px] mt-[10px]">
                                <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                                  <div className="flex items-center">
                                    <p className="text-[14px] font-medium w-[88px] h-[21px] text-black">
                                      Store Name
                                    </p>
                                  </div>
                                  <input
                                    name="storeName"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.storeName}
                                    className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                    placeholder="Enter your Store name"
                                  />
                                  {errors.storeName && (
                                    <p className="text-red-600 text-[12px]">
                                      {errors.storeName}
                                    </p>
                                  )}
                                </div>

                                <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                                  <div className="flex items-center">
                                    <p className="text-[14px] font-medium w-[93px] h-[21px] text-black">
                                      GST Number
                                    </p>
                                  </div>
                                  <input
                                    name="gstNumber"
                                    disabled={userData?.gstNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={
                                      userData?.gstNumber || values.gstNumber
                                    }
                                    className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                    placeholder="Enter your 15 Digit GST number"
                                  />
                                  {errors.gstNumber && (
                                    <p className="text-red-600 text-[12px]">
                                      {errors.gstNumber}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="flex mt-[5px] w-full pl-[29px] gap-x-[17px]">
                                <div className="flex flex-col ml-0 text-left w-[164px]">
                                  <p className="text-[14px] font-medium w-[59px] text-black">
                                    Country
                                  </p>
                                  <select
                                    className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                    name="country" // Make sure the name matches the field name in initialValues
                                    value={values.country} // Set the value from Formik's state
                                    onChange={handleChange} // Call handleChange to update Formik's state
                                  >
                                    <option className="text-[#B3B3B3]" value="">
                                      Select Country
                                    </option>
                                    {options.map((option) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div className="col-start-4 col-end-7">
                                  <div className="flex flex-col float-start ml-0 text-left w-[164px]">
                                    <p className="text-[14px] font-medium w-[59px] text-black">
                                      State
                                    </p>
                                    <select
                                      className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                      name="state"
                                      value={values.state}
                                      onChange={handleChange}
                                    >
                                      <option
                                        className="text-[#B3B3B3]"
                                        value=""
                                      >
                                        Select State
                                      </option>
                                      {options.map((option) => (
                                        <option
                                          key={option.value}
                                          value={option.value}
                                        >
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-start-7 col-end-13">
                                  <div className="flex flex-col float-start ml-0 text-left w-[164px]">
                                    <p className="text-[14px] font-medium w-[59px] text-black">
                                      City
                                    </p>
                                    <select
                                      className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                      name="city"
                                      value={values.city}
                                      onChange={handleChange}
                                    >
                                      <option
                                        className="text-[#B3B3B3]"
                                        value=""
                                      >
                                        Select City
                                      </option>
                                      {options.map((option) => (
                                        <option
                                          key={option.value}
                                          value={option.value}
                                        >
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="flex flex-col float-start pl-[29px] text-left w-full mt-[5px]">
                                <p className="text-[14px] font-medium w-[109px] h-[21px] text-black">
                                  Address
                                </p>
                                <textarea
                                  name="address"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.address}
                                  rows="2"
                                  maxlength="150"
                                  className="w-[526px] h-[55px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3] resize-none"
                                  placeholder="Enter Company Address"
                                />
                              </div>

                              <div className="flex pt-[10px] w-[548px] gap-x-[12px] ml-[29px] ">
                                <label>
                                  <input
                                    name="isAgree"
                                    className="h-[20px] w-[20px]"
                                    type="checkbox"
                                    value={values.isAgree}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                </label>
                                <p className="text-[12px] pr-[10px] font-medium text-left w-[500px]">
                                  I Agree To Terms & Conditions I agree to
                                  <span className="text-[#FF6300]">
                                    {" "}
                                    (a) Terms Of Use{" "}
                                  </span>
                                  and
                                  <span className="text-[#FF6300]">
                                    {" "}
                                    (b) Privacy Policy.
                                  </span>{" "}
                                  I agree to receive more information from
                                  Naayatrade.com about its products and
                                  services.
                                </p>
                              </div>
                              {errors.isAgree && (
                                <p className="text-red-600 text-[12px]">
                                  {errors.isAgree}
                                </p>
                              )}
                              {emailStatus && (
                                <p className="text-red-600 text-[12px]">
                                  {emailStatus}
                                </p>
                              )}

                              <div className="w-full flex items-center justify-center">
                                {!loader ? (
                                  <button
                                    type="submit"
                                    onClick={() => {
                                      handleSubmit();
                                      toggleVerifyName();
                                    }}
                                    className="text-white bg-[#FF6300] w-[130px] h-[48px] rounded-[10px] mt-[15px] flex items-center justify-center"
                                  >
                                    REGISTER
                                  </button>
                                ) : (
                                  <button className="register-button text-white bg-[#FF6300] w-[130px] h-[48px] rounded-[10px] mt-[15px] flex items-center justify-center">
                                    <CircularProgress
                                      color="inherit"
                                      size={24}
                                    />
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                        </Formik>
                      </div>
                    </div>
                  )}
                </div>
              </button>
            </div>
            <div className="flex items-center gap-2">
              <img src={Profile} alt="" />
              <p className="text-[12px] font-normal">Sign in</p>
            </div>
          </div>
        </div>
        <div className="">
          {/* First section with background image */}
          <div
            className="w-full h-[485px] bg-cover bg-center"
            style={{ backgroundImage: `url(${background})` }}
          >
            <div className="w-[1240px] h-[545px] m-auto flex items-center gap-40">
              <div>
                <img src={Naay} alt="" className="w-[103px] h-[103px]" />
                <p className="w-[215px] h-[35px] text-[#FF6300] font-medium text-[20px] mt-2">
                  NAAYATRADE
                </p>
                <p className="w-[197px] h-[19px] font-normal text-[14px]">
                  New era of
                  <span className="font-semibold bg-[#FFF7CB] ml-1">
                    Doing Business.
                  </span>
                </p>
              </div>

              <div className="relative w-[556px] h-[456px]">
                <img
                  src={laptop}
                  alt=""
                  className="w-[445px] h-[345px] mt-10 mx-auto"
                />

                <div className="absolute left-[-140px] top-[65%] transform translate-y-[-50%] flex w-[265px] h-[60px] mt-10 bg-[#E9F0FF] gap-3 items-center rounded-lg">
                  <p className="w-[198px] h-[21px] text-[14px] font-semibold ml-2">
                    Find new Seller across India
                  </p>
                  <img src={flag} alt="" />
                </div>

                <div className="absolute right-[-70px] top-[20%] transform translate-y-[-70%] flex w-[245px] h-[60px] bg-[#FFF7CB] gap-1 items-center rounded-lg">
                  <img src={naaya} alt="" className="w-[30px] h-[30px] ml-3" />
                  <p className="w-[190px] h-[21px] text-[14px] font-semibold ml-2">
                    Join Naayatrade.com
                  </p>
                </div>

                <div className="absolute right-[-150px] top-[65%] transform translate-y-[-50%] flex w-[265px] h-[60px] bg-[#DDFFCD] gap-1 items-center rounded-lg">
                  <img src={loan} alt="" className="w-[30px] h-[30px] ml-3" />
                  <p className="w-[208px] h-[24px] text-[14px] font-semibold ml-2">
                    Buy everything at 0%* commission
                  </p>
                </div>
              </div>

              <div className=" w-[300px] h-[100px] ml-20 ">
                <p className=" w-[350px] text-[16px] font-semibold pb-2">
                  Start selling starting from{" "}
                  <span className="text-[#FF6300]">INR 2,999/mo</span>
                </p>
                <ul className="list-disc list-item ml-5">
                  <li className="text-[14px] font-normal">1 storefront</li>
                </ul>
                <ul className="list-disc list-item ml-5">
                  <li className="text-[14px] font-normal">
                    Thousands of active B2B sellers
                  </li>
                </ul>
                <ul className="list-disc list-item ml-5">
                  <li className="text-[14px] font-normal">0% commission</li>
                </ul>
                <ul className="list-disc list-item ml-5">
                  <li className="text-[14px] font-normal text-[#FF6300]">
                    {" "}
                    And much more…
                  </li>
                </ul>
                <button className="w-[135px] h-[46px] bg-[#FF6300] text-white rounded-3xl mt-3">
                  Start Selling
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Service />
      <Branding />
       <SectionData /> 
      <Carsoule /> 
    </>
  );
};

export default LandingPage;
